import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { ReactSVG } from 'react-svg';

const CUSTOM_COLORS = {
  'gray-06': '#414B5C',
  white: '#FFFFFF',
};

function Icon({
  color = 'inherit',
  fontSize = 'small',
  htmlColor,
  isTitle = false,
  type = 'icon-warning',
  tooltip,
  tooltipArrow = true,
  tooltipClasses,
  tooltipPlacement = 'top',
  ...props
}) {
  const svgContext = require.context('./svg', false, /\.svg$/);
  const src = hasIcon() ? svgContext(`./${type}.svg`) : '';

  function hasIcon() {
    return svgContext.keys().find((item) => item === `./${type}.svg`);
  }

  const isCustomColor = CUSTOM_COLORS[color];
  const resolvedColor = isCustomColor ? 'inherit' : color;
  const resolvedHtmlColor = isCustomColor ? CUSTOM_COLORS[color] : htmlColor;

  const iconElement = (
    <SvgIcon color={resolvedColor} fontSize={fontSize} htmlColor={resolvedHtmlColor} {...props}>
      <ReactSVG src={src} wrapper={'svg'} />
    </SvgIcon>
  );

  return (
    <>
      {tooltip ? (
        <Tooltip title={tooltip} placement={tooltipPlacement} arrow={tooltipArrow} classes={tooltipClasses}>
          {iconElement}
        </Tooltip>
      ) : (
        iconElement
      )}
      {isTitle && <p style={{ fontSize: 10, marginTop: 12 }}>{type}</p>}
    </>
  );
}

Icon.propTypes = {
  color: PropTypes.oneOf(['inherit', 'action', 'disabled', 'primary', 'secondary', 'error', 'gray-06', 'white']),
  fontSize: PropTypes.oneOf(['inherit', 'large', 'medium', 'small']),
  htmlColor: PropTypes.string,
  isTitle: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipArrow: PropTypes.bool,
  tooltipClasses: PropTypes.object,
  tooltipPlacement: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top',
  ]),
  type: PropTypes.string,
};

export default Icon;
